"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVITY_MAPPER = exports.DISPLAYABLE_ACTIVITY_TYPES = void 0;
exports.DISPLAYABLE_ACTIVITY_TYPES = ['start', 'end', 'work'];
exports.ACTIVITY_MAPPER = {
    /*
    * Keys - [start, travel, workTravel, work, end] are types of Activity received from BackEnd
    * Mapper stores corresponded data to every activity type
    * defaults:
    *     isTimeRange = true
    *     hasLine = true
    *     projectName - for the start, end
    * */
    start: {
        icon: 'alarm_on',
        iconMap: 'assets/icons/alarm_on.svg',
        projectName: 'Vertrek',
        label: 'Vertrek',
        isTimeRange: false,
    },
    travel: {
        icon: 'directions_bus',
        iconMap: 'assets/icons/building.svg',
        label: 'Reisuren',
    },
    work: {
        icon: 'location_on',
        iconMap: 'assets/icons/project.svg',
        label: 'Gewerkte',
        isTimeRange: true,
    },
    workTravel: {
        icon: 'link',
        label: 'Reisuren-Gewerkte',
        isTimeRange: true,
    },
    end: {
        hasLine: false,
        iconMap: 'assets/icons/marker.svg',
        projectName: 'Aankomst',
        icon: 'alarm_off',
        label: 'Aankomst',
        isTimeRange: false,
    },
};
